// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.room-settings-sidebar {
  display: flex;
  flex-direction: column;
  background-color: #F2F2F2;
  min-width: 281px;
  padding-top: 24px;
}

.room-settings-sidebar-button {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 16px 24px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #4A4A4A;
  width: 100%;
  line-height: 1.2;
}

.room-settings-sidebar-button ion-icon {
  font-size: 24px;
  color: #4A4A4A;
  flex-shrink: 0;
}

.room-settings-sidebar-button:hover {
  background-color: #E8E8E8;
}

.room-settings-sidebar-button.active {
  background-color: #D8D8D8;
  color: #2D2D2D;
}

.room-settings-sidebar-button.active ion-icon {
  color: #2D2D2D;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/RoomSettings/SideBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gGAAgG;EAChG,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".room-settings-sidebar {\n  display: flex;\n  flex-direction: column;\n  background-color: #F2F2F2;\n  min-width: 281px;\n  padding-top: 24px;\n}\n\n.room-settings-sidebar-button {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  padding: 16px 24px;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  color: #4A4A4A;\n  width: 100%;\n  line-height: 1.2;\n}\n\n.room-settings-sidebar-button ion-icon {\n  font-size: 24px;\n  color: #4A4A4A;\n  flex-shrink: 0;\n}\n\n.room-settings-sidebar-button:hover {\n  background-color: #E8E8E8;\n}\n\n.room-settings-sidebar-button.active {\n  background-color: #D8D8D8;\n  color: #2D2D2D;\n}\n\n.room-settings-sidebar-button.active ion-icon {\n  color: #2D2D2D;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
